import localeText from "../../../../locale";
import Loading from "../../../../components/Loading/Loading";
import ProductCard from "../../../ProductInfo/components/ProductCard/ProductCard";
import SearchFilters from "../FiltersInSearch/FiltersInSearch";
import { Paginator } from "primereact/paginator";
import { useEffect, useState } from "react";
import ProductService from "../../../../service/ProductService";
import ProductSectionsLoading from "../ProductSectionsLoading/ProductSectionsLoading";
import useLoadingSimulation from "../../hooks/useLoadingSimulation";
import { Skeleton } from "primereact/skeleton";
import { useLocation } from "react-router-dom";
import { parseFringeBenefit } from "../../../../utilities/parsers/product";

const Products = ({
  isSelectedCategory,
  products,
  isLoading,
  searchMessage,
  searchQueryParam,
  searchParams,
  setSearchParams,
  visible,
  onHide,
  isLoadingStoreNames,
  storeNames,
  setProducts,
  totalPages,
  totalProducts,
  fringeBenefitsSubCategories,
}) => {
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(12);
  const [records, setRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const url = useLocation();
  const isFringeBenefitsPage = url?.pathname?.toLowerCase()?.includes("fringe");

  const isLoadingSimulation = useLoadingSimulation();
  const productService = new ProductService();

  useEffect(() => {
    if (products) {
      setRecords(products.length);
    }
  }, [products]);

  const noPagination = currentPage === 1 && records === 0;

  const onPageChange = async (event) => {
    window.scrollTo(0, 0);
    setFirst(event.first);
    setRows(event.rows);
    setCurrentPage(event.page + 1);

    if (isFringeBenefitsPage) {
      const response = await productService.searchFringeBenefit({
        expression: searchQueryParam,
        page: event.page,
      });

      setProducts(
        response.result.content
          .filter((product) => product.productStatus === "PUBLISHED")
          .map(parseFringeBenefit)
      );
    } else {
      const response = await productService.searchByTitle(
        searchQueryParam,
        searchParams.currency,
        searchParams.type,
        searchParams.seller,
        searchParams.area,
        searchParams.category,
        event.page,
        12
      );

      setProducts(response.result.content);
    }
  };

  if (isLoading && !searchMessage)
    return (
      <div className="flex gap-3 w-full align-items-start">
        <Skeleton width="13.5rem" height="40rem" />
        <div className="w-full">
          <ProductSectionsLoading />
        </div>
      </div>
    );

  if (!searchMessage && isSelectedCategory && products?.length === 0)
    return (
      <div
        className="flex flex-column gap-2 justify-content-center align-items-center text-gray-600 w-full align-self-center"
        style={{ minHeight: "30vh" }}
      >
        <i className="pi pi-search text-6xl text-gray-500"></i>
        <strong className="lg:text-xl text-base">{localeText("noProductsInCategory")}</strong>
      </div>
    );

  return (
    <div className="flex w-full align-items-start">
      {searchMessage && searchQueryParam && (
        <SearchFilters
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          visible={visible}
          onHide={onHide}
          isLoading={isLoading}
          isLoadingStoreNames={isLoadingStoreNames}
          storeNames={storeNames}
          fringeBenefitsSubCategories={fringeBenefitsSubCategories}
        />
      )}

      {isLoading ? (
        <div className="w-full">
          <ProductSectionsLoading />
        </div>
      ) : (
        <div className="grid grid-nogutter w-full">
          <div className="shop-products-section w-full">
            {searchQueryParam && products?.length === 0 && (
              <p
                className="text-center mx-2 mt-5 align-content-center"
                style={{ height: "10vh", gridColumn: "1/-1" }}
              >
                {localeText("noProductsInSearch")}
              </p>
            )}

            {(searchQueryParam || isSelectedCategory) &&
              products?.map((product) => {
                return <ProductCard key={`shop${product.id}`} product={product} />;
              })}
          </div>

          {(searchQueryParam || isSelectedCategory) && totalProducts > 12 && !noPagination && (
            <div className="col-12 flex justify-content-start">
              <Paginator
                first={first}
                rows={rows}
                totalRecords={totalProducts}
                page={currentPage}
                onPageChange={onPageChange}
                pageLinkSize={3}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Products;
